import { css, SerializedStyles } from '@emotion/core';
import styled from '@emotion/styled';
import { rem } from '../../styles/theme/layout';
import { AppTheme } from '../../styles/theme';

/* consistency between label and input */
const FONT_SIZE = rem(14);

export const PADDING_SIDE = rem(18);

const halfContainerStyle = `
  display: inline-block;
  width: calc(50% - 6px);
`;

export const Container = styled.div`
  position: relative;

  &:not(:last-of-type) {
    margin-bottom: ${rem(12)};
  }

  ${({ half }: { half?: boolean }) =>
    half === true &&
    `
    ${halfContainerStyle}
    margin-right: ${rem(6)};

    & + * {
      ${halfContainerStyle}
      margin-left: ${rem(6)};
    }`}
`;

export const Label = styled.label`
  font-size: ${FONT_SIZE};
  color: ${({ theme }) => (theme as AppTheme).colors.labelGray};
  font-style: italic;
  padding: ${PADDING_SIDE};
  position: absolute;
  left: 0;
  transition: all 0.1s ease-out;
  cursor: text;
`;

export const fieldStyles = ({
  theme,
}: {
  theme: AppTheme;
}): SerializedStyles => css`
  border: 1px solid transparent;
  border-radius: ${theme.radii.normal};
  box-shadow: 0 1px 3px #cfdde6;
  color: ${theme.colors.black};
  padding: ${rem(22)} ${PADDING_SIDE} ${rem(14)} ${PADDING_SIDE};
  width: 100%;
  font-size: ${FONT_SIZE};
  transition: all 0.1s ease-out;
  appearance: none;
`;

export const floatingStyles: SerializedStyles = css`
  font-size: ${rem(12)};
  padding-top: ${rem(5)};
  font-style: normal;
  pointer-events: none;
`;

export const Arrow = styled.img`
  position: absolute;
  top: 25px;
  right: ${PADDING_SIDE};
`;

export const invalidStyles = ({
  theme,
}: {
  theme: AppTheme;
}): SerializedStyles => css`
  &[aria-invalid='true'] {
    border-color: ${theme.colors.red};

    & + label {
      color: ${theme.colors.red};
    }
  }
`;
